export default __webpack_public_path__ + "static/media/Pear.a542c60d.png";